"use client";

import { createContext } from "react";
import { AlertColor } from "@mui/material";

export interface ToastAddMessage {
  type: AlertColor;
  title?: string;
  subtitle?: string;
  style?: "generic" | "standard";
  link?: { text: string; href: string };
}

export interface ToastContextType {
  addMessage: (props: ToastAddMessage) => void;
}

export const ToastContext = createContext<ToastContextType>({
  addMessage: () => {},
});
